<template>
  <div
    class="bg-gray-50 px-4 py-2 text-left text-sm font-semibold text-gray-900 flex justify-between items-center w-full border-b sm:rounded-t-lg"
  >
    <slot></slot>
  </div>
</template>
